/**
 * src/mcp/components/MCPToolList.jsx
 *
 * Relocated from src/components/MCPToolList.jsx — grouped with the rest of
 * the MCP chat feature (folder-structure cleanup). Content unchanged.
 *
 * Collapsible list of available MCP tools
 */
import { useState } from 'react';

export default function MCPToolList({ tools, servers }) {
  const [expanded, setExpanded] = useState(false);
  const [expandedServers, setExpandedServers] = useState({});

  // Group tools by server
  const toolsByServer = tools.reduce((acc, tool) => {
    if (!acc[tool.server]) acc[tool.server] = [];
    acc[tool.server].push(tool);
    return acc;
  }, {});

  const toggleServer = (serverName) => {
    setExpandedServers(prev => ({
      ...prev,
      [serverName]: !prev[serverName]
    }));
  };

  if (tools.length === 0) {
    return null;
  }

  return (
    <div className="mcp-tool-list">
      <div
        className="mcp-tool-header"
        onClick={() => setExpanded(!expanded)}
      >
        <h3>
          <span className="mcp-expand-icon">{expanded ? '▼' : '▶'}</span>
          Tools ({tools.length})
        </h3>
      </div>

      {expanded && (
        <div className="mcp-tool-content">
          {Object.entries(toolsByServer).map(([serverName, serverTools]) => (
            <div key={serverName} className="mcp-tool-server">
              <div
                className="mcp-tool-server-header"
                onClick={() => toggleServer(serverName)}
              >
                <span className="mcp-expand-icon">
                  {expandedServers[serverName] ? '▼' : '▶'}
                </span>
                <span className="mcp-server-label">{serverName}</span>
                <span className="mcp-tool-count">{serverTools.length}</span>
              </div>

              {expandedServers[serverName] && (
                <div className="mcp-tool-items">
                  {serverTools.map(tool => (
                    <div key={tool.name} className="mcp-tool-item">
                      <div className="mcp-tool-name">{tool.name}</div>
                      <div className="mcp-tool-desc">{tool.description}</div>
                      {tool.inputSchema?.properties && (
                        <div className="mcp-tool-params">
                          {Object.entries(tool.inputSchema.properties).map(([param, schema]) => (
                            <span key={param} className="mcp-param">
                              {param}: {schema.type}
                            </span>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      <style>{`
        .mcp-tool-list {
          border-bottom: 1px solid #2a2a2e;
        }

        .mcp-tool-header {
          padding: 12px 16px;
          cursor: pointer;
          user-select: none;
        }

        .mcp-tool-header:hover {
          background: #1c1c1f;
        }

        .mcp-tool-header h3 {
          margin: 0;
          font-size: 12px;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          color: #71717a;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .mcp-expand-icon {
          font-size: 10px;
          color: #71717a;
        }

        .mcp-tool-content {
          padding: 0 16px 12px;
        }

        .mcp-tool-server {
          margin-bottom: 8px;
        }

        .mcp-tool-server-header {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 8px;
          background: #1c1c1f;
          border-radius: 4px;
          cursor: pointer;
          user-select: none;
        }

        .mcp-tool-server-header:hover {
          background: #252528;
        }

        .mcp-server-label {
          font-size: 12px;
          font-weight: 500;
          color: #10b981;
          font-family: monospace;
          flex: 1;
        }

        .mcp-tool-count {
          font-size: 11px;
          color: #71717a;
          background: #0a0a0b;
          padding: 2px 6px;
          border-radius: 10px;
        }

        .mcp-tool-items {
          padding: 8px 0 0 20px;
        }

        .mcp-tool-item {
          padding: 8px 10px;
          margin-bottom: 4px;
          background: #18181b;
          border-radius: 4px;
          border-left: 2px solid #2a2a2e;
        }

        .mcp-tool-item:hover {
          border-left-color: #10b981;
        }

        .mcp-tool-name {
          font-size: 12px;
          font-weight: 500;
          color: #e4e4e7;
          font-family: monospace;
          margin-bottom: 2px;
        }

        .mcp-tool-desc {
          font-size: 11px;
          color: #71717a;
          line-height: 1.4;
        }

        .mcp-tool-params {
          display: flex;
          flex-wrap: wrap;
          gap: 4px;
          margin-top: 6px;
        }

        .mcp-param {
          font-size: 10px;
          font-family: monospace;
          background: #0a0a0b;
          padding: 2px 6px;
          border-radius: 3px;
          color: #a1a1aa;
        }
      `}</style>
    </div>
  );
}
